import { useState, useEffect } from "react";
import { db } from "../../firebase/firebase-config";
import { collection, getDocs, addDoc, deleteDoc, doc } from "firebase/firestore";
import { Link } from "react-router-dom";
import {useDispatch} from "react-redux";
import {setPageTitle} from "../../store/themeConfigSlice";

export default function VisitsPage() {
    const [visits, setVisits] = useState([]);
    const [patients, setPatients] = useState([]);
    const [selectedPatient, setSelectedPatient] = useState("");
    const [patientMap, setPatientMap] = useState({});
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setPageTitle("Visits Page"));
    }, [dispatch]);

    useEffect(() => {
        const fetchData = async () => {
            const visitsSnapshot = await getDocs(collection(db, "visits"));
            const patientsSnapshot = await getDocs(collection(db, "patients"));

            const patientList = patientsSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
            const patientDictionary = patientList.reduce((acc, patient) => {
                acc[patient.id] = patient;
                return acc;
            }, {});

            setPatients(patientList);
            setPatientMap(patientDictionary);
            setVisits(visitsSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
        };
        fetchData();
    }, []);

    const addVisit = async () => {
        if (!selectedPatient) return alert("Pilih pasien terlebih dahulu!");
        const newVisit = {
            patientId: selectedPatient,
            painDetails: {},
            interventionRecords: [],
            timestamp: new Date()
        };
        await addDoc(collection(db, "visits"), newVisit);
        alert("Kunjungan berhasil ditambahkan!");
        setSelectedPatient("");
        window.location.reload();
    };

    const deleteVisit = async (visitId) => {
        if (window.confirm("Apakah Anda yakin ingin menghapus kunjungan ini?")) {
            await deleteDoc(doc(db, "visits", visitId));
            alert("Kunjungan berhasil dihapus!");
            setVisits(visits.filter((visit) => visit.id !== visitId));
        }
    };

    return (
        <div className="p-6">
            <h1 className="text-2xl font-bold mb-4">Daftar Kunjungan</h1>
            <div className="mb-4">
                <label className="block mb-2">Pilih Pasien:</label>
                <select
                    className="border p-2 w-full"
                    value={selectedPatient}
                    onChange={(e) => setSelectedPatient(e.target.value)}
                >
                    <option value="">-- Pilih Pasien --</option>
                    {patients.map((patient) => (
                        <option key={patient.id} value={patient.id}>
                            {patient.name} ({patient.email})
                        </option>
                    ))}
                </select>
                <button className="mt-2 bg-blue-500 text-white px-4 py-2 rounded" onClick={addVisit}>
                    Tambah Kunjungan
                </button>
            </div>
            {visits.length === 0 ? (
                <p>Belum ada kunjungan.</p>
            ) : (
                <table className="w-full border-collapse border border-gray-300">
                    <thead>
                    <tr className="bg-gray-200">
                        <th className="border p-2">No.</th>
                        <th className="border p-2">Nama Pasien</th>
                        <th className="border p-2">Email</th>
                        <th className="border p-2">Timestamp</th>
                        <th className="border p-2">Aksi</th>
                    </tr>
                    </thead>
                    <tbody>
                    {visits.map((visit, index) => (
                        <tr key={visit.id} className="hover:bg-gray-100">
                            <td className="border p-2">{index + 1}</td>
                            <td className="border p-2">
                                <Link to={`/visits/${visit.id}`} className="text-blue-500 underline">
                                    {patientMap[visit.patientId]?.name || "Unknown"}
                                </Link>
                            </td>
                            <td className="border p-2">{patientMap[visit.patientId]?.email || "Unknown"}</td>
                            <td className="border p-2">
                                {visit.timestamp?.toDate ? new Date(visit.timestamp.toDate()).toLocaleString() : "Invalid Date"}
                            </td>
                            <td className="border p-2 text-center">
                                <button className="bg-red-500 text-white px-2 py-1 rounded" onClick={() => deleteVisit(visit.id)}>
                                    Hapus
                                </button>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}